/* Sticky add-to-cart iOS visual-viewport shim (safe with Minimog) */
(function () {
  const bar = document.querySelector('.m-sticky-addtocart');
  if (!bar || !window.visualViewport) return;

  function nudge () {
    const gap = Math.max(0, window.innerHeight - window.visualViewport.height);
    if (gap > 0) {
      // Keep Minimog’s visibility logic and only add the gap on top
      bar.style.transform = `translate3d(0, calc(var(--m-translate-y, 100%) + ${gap}px), 0)`;
    } else {
      // Let the stock CSS/JS control visibility
      bar.style.transform = '';
    }
  }

  nudge();
  window.visualViewport.addEventListener('resize', nudge);
})();
